import React from 'react';

import FormattedHTMLMessage from '../../../../src/components/general/FormattedHTMLMessage';

export default function SmartcardNumberHelp () {
    return (
        <div>
            <FormattedHTMLMessage splitParagraphs tagName="p" message="delayrepay.help.smartcardNumber" />
            <div className={ `delayrepay--smartcard-number-help` } />
        </div>
    );
}
